import { useIntl } from 'react-intl';

import { definedTranslation } from '../../i18n';

export function useRequestQuoteTranslations() {
  const intl = useIntl();

  const UNIT_OF_MEASURE_VALUE_MAP: Record<string, string> = {
    'Per Unit': intl?.formatMessage(
      definedTranslation.unitOfMeasure.unitsLabel,
    ),
    'Per Linear Foot': intl?.formatMessage(
      definedTranslation.unitOfMeasure.linearFtLabel,
    ),
    'Per Linear Yard': intl?.formatMessage(
      definedTranslation.unitOfMeasure.linearYardsLabel,
    ),
    'Per Square Foot': intl?.formatMessage(
      definedTranslation.unitOfMeasure.sqFtLabel,
    ),
    'Per Gallon': intl?.formatMessage(
      definedTranslation.unitOfMeasure.gallonsLabel,
    ),
    'Per Linear Meter':
      intl?.formatMessage(definedTranslation.unitOfMeasure.linearMetersLabel) ??
      'm',
    'Per Square Meter':
      intl?.formatMessage(definedTranslation.unitOfMeasure.sqMetersLabel) ??
      'm²',
    // EU standardized units of measure (these do not need intl translations)
    'Per Millimeter': 'mm',
    'Per Centimeter': 'cm',
    'Per Meter': 'm',
    'Per Gram': 'g',
    'Per Kilogram': 'kg',
    'Per Milliliter': 'ml',
    'Per Liter': 'L',
  };

  return {
    UNIT_OF_MEASURE_VALUE_MAP,
  };
}
